/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { BigModal } from './BigModal';
import { Typography, Grid, Tabs, Tab, Box } from '@mui/material';
import { CustomTextField, InspectEmpDetails, ContainedButton } from '../index';
import { useEffect, useState } from 'react';

export const InspectEmpModal = (props) => {
  const [lastname, setLastname] = useState('');
  const [firstname, setFirstname] = useState('');
  const [username, setUsername] = useState('');
  const [middlename, setMiddleName] = useState('');
  const [email, setEmail] = useState('');
  const [tabValue, setTabValue] = useState('personalInfo');

  // Wait for props to load
  useEffect(() => {
    setLastname(props.lastname);
    setFirstname(props.firstname);
    setUsername(props.username);
    setMiddleName(props.middlename);
    setEmail(props.email);
  }, [
    props.firstname,
    props.lastname,
    props.username,
    props.middlename,
    props.email,
  ]);

  const handleTabChange = (event, value) => {
    setTabValue(value);
  };

  const handleClose = () => {
    props.onClose();
    setTabValue('personalInfo');
  };

  return (
    <>
      <BigModal
        style={{ display: 'flex', flexDirection: 'column' }}
        width={'80%'}
        open={props.open}
        onClose={handleClose}
      >
        <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
          Inspect employee:
        </Typography>

        <Grid container columnSpacing={4}>
          <Grid item xs={6}>
            <CustomTextField label="First Name" value={firstname} />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField label="Last Name" value={lastname} />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField label="Middle Name" value={middlename} />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField label="Username" value={username} />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField label="Email" value={email} />
          </Grid>
        </Grid>

        <Box
          sx={{
            width: '100%',
            overflowY: 'auto',
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab value="personalInfo" label="Personal Information" />
            <Tab value="addresses" label="Addresses" />
            <Tab
              value="familyBackground"
              label="Family Background & Relations"
            />
            <Tab value="educBackground" label="Educational Background" />
            <Tab value="civService" label="Civil Service Eligibility" />
            <Tab value="workExp" label="Work Experience" />
            <Tab value="volWork" label="Voluntary Work" />
            <Tab value="trainingProgs" label="Training Programs" />
            <Tab value="history" label="History" />
          </Tabs>

          <Box sx={{}}>
            <InspectEmpDetails
              viewOnly={true}
              currentTab={tabValue}
              empid={props.empid}
            />
          </Box>
        </Box>

        <Box display="flex">
          <ContainedButton
            onClick={handleClose}
            variant="contained"
            btnTitle="Close"
            style={{ width: 'auto', mt: 2, ml: 'auto' }}
          />
        </Box>
      </BigModal>
    </>
  );
};
